import { render, staticRenderFns } from "./CategorySelectBox.vue?vue&type=template&id=64922c88"
import script from "./CategorySelectBox.vue?vue&type=script&lang=js"
export * from "./CategorySelectBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports